
/**
 * Check if auto-delete is enabled for the current user
 * @returns {boolean} - true if auto-delete is enabled, false otherwise
 */
export const isAutoDeleteEnabled = () => {
  try {
    const userData = localStorage.getItem('user');
    if (userData) {
      const user = JSON.parse(userData);
      return user.autoDeleteEnabled === true;
    }
    return false;
  } catch (error) {
    console.error('Error checking auto-delete status:', error);
    return false;
  }
};

/**
 * Set auto-delete preference for the current user
 * @param {boolean} enabled - whether to enable auto-delete
 */
export const setAutoDeletePreference = (enabled) => {
  try {
    const userData = localStorage.getItem('user');
    if (userData) {
      const user = JSON.parse(userData);
      user.autoDeleteEnabled = enabled;
      localStorage.setItem('user', JSON.stringify(user));
      return true;
    }
    return false;
  } catch (error) {
    console.error('Error setting auto-delete preference:', error);
    return false;
  }
};
